import React, { useState, useEffect, } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import zhCN from 'antd/lib/date-picker/locale/zh_CN';
import 'moment/locale/zh-cn';
import { Breadcrumb, DatePicker, Space, Select, Button, message, Input, Switch } from 'antd';
import moment from 'moment';
import { request } from "@/utils";
import "./index.less";
import Calendar from '@/components/calendar';
import { formatDate, convertDateToTimestamp } from '@/utils/func';
// import MultipleDatePicker from './';

export default function SubOrderForm() {

    const navigate = useNavigate();
    const location = useLocation();
    const [detail, setDetail] = useState({});
    const searchParams = new URLSearchParams(location.search);
    const [vacancyDate, setVacancyDate] = useState([])
    const [selectedDate, setSelectedDate] = useState(null);
    const [vacancyMember, setVacancyMember] = useState([])
    const [vacancyTime, setVacancyTime] = useState([])
    const [alternativeTime01, setAlternativeTime01] = useState([])
    const [alternativeTime02, setAlternativeTime02] = useState([])
    const [b1ReservationDate, setB1ReservationDate] = useState(null)
    const [b2ReservationDate, setB2ReservationDate] = useState(null)
    const [b1ReservationTime, setB1ReservationTime] = useState(null)
    const [b2ReservationTime, setB2ReservationTime] = useState(null)
    const [selectMemberText, setSelectMemberText] = useState(null)
    const [selectTimeText, setSelectTimeText] = useState(null)
    const [meal, setMeal] = useState([])
    const [adjust, setAdjust] = useState(false);
    const [selectMeal, setSelectMeal] = useState({})
    const [selectSeatText, setSelectSeatText] = useState({})
    const [seatList, setSeatList] = useState([])

    const fetchData = async () => {
        try {
            const response = await request.get('restaurant/detail?id=' + searchParams.get("id"));
            setDetail(response.data || {})
            let seat = []
            response.data.seat?.forEach((v) => {
                seat.push({ value: v.id, label: `${v.name}` })
            })
            setSeatList([...seat])
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };
    const reservationFindMeal = async () => {
        const response = await request.get('restaurant/find-meal?page=1&page_size=100&restaurant_id=' + detail.id + '&person_num=' + selectMemberText + '&seat_id=' + selectSeatText?.value + '&appointment_time=' + selectTimeText);
        let meal = []
        response?.data?.forEach((v) => {
            meal.push({ value: v.id, label: `${v.name}        JPY ${v.price}/人`, deposit: v.deposit, name: v.name })
        })
        setMeal(meal || [])
    }
    useEffect(() => {
        console.log('refresh')
        fetchData();
        getVacancyDate()
    }, []);
    const onDayClick = (day) => {
        console.log(day)
        setVacancyMember([])
        setVacancyTime([])
        setSelectTimeText(null)
        setSelectMemberText(null)
        setSelectedDate(day.value)
        getVacancyMember(day.value)
        setAlternativeTime01([])
        setAlternativeTime02([])
        setB1ReservationTime(null)
        setB2ReservationTime(null)
        setAdjust(false)
        setSelectMeal({})
        setMeal([])
    }
    const onRest = () => {
        setVacancyTime([])
        setSelectTimeText(null)
        setSelectMemberText(null)
        setB1ReservationTime(null)
        setB2ReservationTime(null)
        setAdjust(false)
        setSelectMeal({})
        setMeal([])
    }
    // 获取预约日期
    const getVacancyDate = async () => {
        const response = await request.get('restaurant/vacancy-date?id=' + searchParams.get("id"));
        let tempData = []
        response.data?.forEach(v => {
            if (v.available > 0) {
                tempData.push({
                    value: formatDate(v.date, 'only')
                })
                //
            }
        })
        console.log(tempData, 'tempData')
        setVacancyDate([...tempData])
    }
    // 获取可预约人数
    const getVacancyMember = async (day) => {
        const response = await request.get('restaurant/vacancy-member?id=' + searchParams.get("id") + '&date=' + day);
        let tempMember = []
        response.data.slice(0, 20)?.forEach(v => {
            tempMember.push({
                value: v.member_num,
                label: v.member_num + '人',
                disabled: v.disabled === 0
            })
        })
        setVacancyMember([...tempMember])
    }
    // 获取可预约时间
    const getfindVacancy = async (day, num, type = 0) => {
        const response = await request.get('restaurant/find-vacancy?id=' + searchParams.get("id") + '&date=' + day + '&num=' + num);
        let tempTime = []
        response.data?.forEach((v) => {
            tempTime.push({
                value: v,
                label: v,
            })
        })
        console.log(type,)
        if (type == 0) {
            setVacancyTime([...tempTime])
        } else if (type == 1) {
            setAlternativeTime01([...tempTime])
        } else {
            setAlternativeTime02([...tempTime])
        }
        setMeal([])
    }
    const sureReservation = async () => {
        if (!selectedDate) {
            message.error('请选择预约日期')
            return
        }
        if (!selectMemberText) {
            message.error('请选择预约人数')
            return
        }
        if (!selectTimeText) {
            message.error('请选择预约时间')
            return
        }
        let newInfo = await request.get('restaurant/detail?id=' + searchParams.get("id"));
        if (newInfo.data.subscription_price !== detail.subscription_price) {
            setDetail(newInfo.data.data)
            message.error('预约费用有变动，请重新确定')
            return
        }
        let moudle = newInfo.data.meal?.find(item => item.id === selectMeal?.value)
        console.log(moudle?.deposit, selectMeal?.deposit, 'ppp')
        if (moudle?.deposit !== selectMeal?.deposit) {
            setSelectMeal(moudle)
            message.error('预约费用有变动，请重新确定')
            return
        }

        if (adjust &&
            ((convertDateToTimestamp(`${selectedDate} ${selectTimeText}`) == convertDateToTimestamp(`${b1ReservationDate} ${b1ReservationTime}`))
                || (convertDateToTimestamp(`${selectedDate} ${selectTimeText}`) == convertDateToTimestamp(`${b2ReservationDate} ${b2ReservationTime}`))
                || (convertDateToTimestamp(`${b1ReservationDate} ${b1ReservationTime}`) == convertDateToTimestamp(`${b2ReservationDate} ${b2ReservationTime}`)))) {
            message.error('请选择不同的预约时间')
            return
        }
        console.log(new Date().getTime() / 1000, convertDateToTimestamp(`${selectedDate} ${selectTimeText}`), 'ppp00')
        if (new Date().getTime() / 1000 > convertDateToTimestamp(`${selectedDate} ${selectTimeText}`)) {
            console.log(new Date().getTime() / 1000, convertDateToTimestamp(`${selectedDate} ${selectTimeText}`), 'ppp11')
            message.error('预约时间段已失效，请重新填写')
            onRest()
            return
        }
        if (!selectMeal?.value) {
            message.error('请选择预约套餐')
            return
        }


        const data = {
            reservation_date: selectedDate,
            reservation_time: selectTimeText,
            reservation_number: selectMemberText,
            adjust: adjust,
            b1_reservation_date: b1ReservationDate,
            b1_reservation_time: b1ReservationTime,
            b1_reservation_number: selectMemberText,
            b2_reservation_date: b2ReservationDate,
            b2_reservation_time: b2ReservationTime,
            b2_reservation_number: selectMemberText,
            meal_id: selectMeal?.value,
            restaurant_id: detail?.id,
            reservation_service_charge: detail?.subscription_price * (selectMemberText * 1),
            meal_deposit: detail.meal.find(item => item.id === selectMeal?.value)?.deposit * (selectMemberText * 1),
            reservation_total_amount: detail?.subscription_price * (selectMemberText * 1) + (detail.meal.find(item => item.id === selectMeal.value)?.deposit * 1) * (selectMemberText * 1),
            seat: selectSeatText?.label,
            meal: selectMeal?.name
        }
        console.log(selectMeal)
        navigate('/SubOrderCommit?id=' + detail.id, { state: { data: data, id: detail?.id } })
    }
    return (
        <>
            <div className="sub-order-content-box">
                <div className="detail-title">
                    <div className="detail-title-box">
                        <Breadcrumb separator=">" style={{ height: "32px", lineHeight: "32px", fontSize: "12px" }}>
                            {sessionStorage.getItem("mbx") === null && <Breadcrumb.Item href="/">主页</Breadcrumb.Item>}
                            {sessionStorage.getItem("mbx") === 'main' && <Breadcrumb.Item href="/">主页</Breadcrumb.Item>}
                            {sessionStorage.getItem("mbx") === 'canteen' && <Breadcrumb.Item href="/canteen">餐厅</Breadcrumb.Item>}
                            {/*<Breadcrumb.Item>*/}
                            {/*    <a href="/">主页</a>*/}
                            {/*</Breadcrumb.Item>*/}
                            <Breadcrumb.Item>
                                <a href={"/detail?id=" + detail.id}>餐厅详情</a>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>餐厅预约</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
                <div className="sub-content">
                    <div className="sub-order-from-store">
                        <div className="sub-order-from-store-name">{detail.name}</div>
                        <div className="sub-order-from-store-tip">预约</div>
                    </div>
                    <div className="sub-order-form">
                        <div className="date-box" id="datePicker-container">
                            <Calendar
                                marks={
                                    vacancyDate
                                }
                                selectedDate={selectedDate}
                                view={'month'}
                                startDay={1}
                                selectedDateColor="#346fc2"
                                onDayClick={(item) => onDayClick(item)}
                            />
                        </div>
                        <div className="form-box">
                            <div className='form-title'>预约信息</div>
                            <div className='form-content'>
                                <div className='form-item'>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                        <div className='form-label' style={{ marginBottom: '0px' }}>预约人数</div>
                                        <div style={{color:'#EA0025'}}>（提示：儿童人数也算至总人数中）</div>
                                    </div>
                                    <Select
                                        style={{ width: '100%' }}
                                        placeholder="请选择预约人数" options={[...vacancyMember]}
                                        onClick={() => {
                                            if (!selectedDate) {
                                                message.error('请先选择预约日期')
                                                return
                                            }
                                        }}
                                        value={selectMemberText}
                                        onChange={(value) => {
                                            setSelectMemberText(value)
                                            getfindVacancy(selectedDate, value, 0)
                                        }}
                                    />

                                </div>
                                <div className='form-item'>
                                    <div className='form-label'>预约时间
                                        <span className='form-label-tip'>(日本当地时间)</span>
                                    </div>
                                    <Select
                                        style={{ width: '100%' }}
                                        onClick={() => {
                                            if (!selectedDate) {
                                                message.error('请先选择预约日期')
                                                return
                                            }
                                            if (!selectMemberText) {
                                                message.error('请先选择预约人数')
                                                return
                                            }

                                        }}
                                        value={selectTimeText}
                                        onChange={(value) => {
                                            setSelectTimeText(value)
                                            setMeal([])
                                            setSelectMeal({})

                                        }}
                                        placeholder="请选择预约时间"
                                        options={[...vacancyTime]}
                                        // 修改为空时显示的提示文字
                                        notFoundContent="当前暂无可预约时间段,请选择其他日期或减少人数重试"
                                    />

                                </div>
                                {
                                    !!seatList?.length && <div className='form-item'>
                                        <div className='form-label'>座位类型
                                        </div>
                                        <Select
                                            style={{ width: '100%' }}
                                            value={selectSeatText?.id}
                                            onChange={(value) => {
                                                const selectedOption = seatList.find(option => option.value === value);
                                                if (selectedOption) {
                                                    setSelectSeatText(selectedOption);
                                                }
                                                setMeal([])
                                                setSelectMeal({})
                                            }}
                                            placeholder="请选择座位类型" // 修正占位符文本，原文本是预约时间，这里应该是座位类型
                                            options={[...seatList]}
                                        />

                                    </div>
                                }

                                <div className='form-switch'>
                                    <div>备选用餐时间：（添加备选时间会提升预约成功率）</div>
                                    <Switch disabled={!selectMemberText} checked={adjust} onChange={(value) => {
                                        if (!value) {
                                            setAlternativeTime01([])
                                            setAlternativeTime02([])
                                        }
                                        setAdjust(value)
                                    }} />
                                </div>
                                {
                                    adjust &&
                                    <div className='form-item'>
                                        <div className='form-label'>备选时间一
                                        </div>
                                        {/* <Select
                                    style={{ width: '30%' }}
                                    placeholder="选择日期" options={[{ value: 'sample', label: '12:00' }]} /> */}
                                        <DatePicker
                                            placeholder="选择日期"
                                            style={{ marginRight: '10px', width: '30%' }}
                                            locale={zhCN}
                                            disabledDate={(current) => {
                                                const threeMonthsFromNow = moment().add(3, 'months');
                                                const isWithinThreeMonths = current.isBefore(threeMonthsFromNow);
                                                const isVacancyDate = vacancyDate.some(date => moment(date.value).isSame(current, 'day'));
                                                return !isWithinThreeMonths || !isVacancyDate;
                                            }}
                                            onSelect={(value) => {
                                                setB1ReservationDate(moment(value).format('YYYY-MM-DD'))
                                                getfindVacancy(moment(value).format('YYYY-MM-DD'), selectMemberText, 1)
                                                setB1ReservationTime(null)
                                            }}

                                        />
                                        <Select
                                            style={{ width: '30%', marginRight: '10px' }}
                                            onClick={() => {
                                                if (!b1ReservationDate) {
                                                    message.error('请先选择备选一日期')
                                                    return
                                                }
                                            }}
                                            value={b1ReservationTime}
                                            onChange={(value) => { setB1ReservationTime(value) }}
                                            placeholder="选择时间" options={[...alternativeTime01]}     // 修改为空时显示的提示文字
                                            notFoundContent="当前暂无可预约时间段,请选择其他日期或减少人数重试" />
                                        <Select
                                            style={{ width: '30%' }}
                                            placeholder="选择人数" options={
                                                selectMemberText == null ? [] :
                                                    [{ value: selectMemberText, label: selectMemberText + '人' }]
                                            }
                                            value={selectMemberText}

                                        />
                                    </div>
                                }
                                {
                                    adjust &&
                                    <div className='form-item'>
                                        <div className='form-label'>备选时间二 </div>
                                        {/* <Select
                                 style={{ width: '30%' }}
                                 placeholder="选择日期" options={[{ value: 'sample', label: '12:00' }]} /> */}
                                        <DatePicker
                                            placeholder="选择日期"
                                            style={{ marginRight: '10px', width: '30%' }}
                                            format="YYYY-MM-DD"
                                            locale={zhCN}
                                            disabledDate={(current) => {
                                                const threeMonthsFromNow = moment().add(3, 'months');
                                                const isWithinThreeMonths = current.isBefore(threeMonthsFromNow);
                                                const isVacancyDate = vacancyDate.some(date => moment(date.value).isSame(current, 'day'));
                                                return !isWithinThreeMonths || !isVacancyDate;
                                            }}
                                            onSelect={(value) => {
                                                setB2ReservationDate(moment(value).format('YYYY-MM-DD'))
                                                getfindVacancy(moment(value).format('YYYY-MM-DD'), selectMemberText, 2)
                                                setB2ReservationTime(null)
                                            }}

                                        />
                                        <Select
                                            style={{ width: '30%', marginRight: '10px' }}
                                            onClick={() => {
                                                if (!b2ReservationDate) {
                                                    message.error('请先选择备选二日期')
                                                    return
                                                }
                                            }}
                                            value={b2ReservationTime}
                                            onChange={(value) => { setB2ReservationTime(value) }}
                                            placeholder="选择时间" options={[...alternativeTime02]} // 修改为空时显示的提示文字
                                            notFoundContent="当前暂无可预约时间段,请选择其他日期或减少人数重试"
                                        />
                                        <Select
                                            style={{ width: '30%' }}
                                            placeholder="选择人数" options={selectMemberText == null ? [] :
                                                [{ value: selectMemberText, label: selectMemberText + '人' }]} value={selectMemberText} />
                                    </div>
                                }
                                <div className='form-item'>
                                    <div className='form-label'>预约套餐</div>
                                    <Select
                                        onClick={() => {
                                            if (seatList?.length > 0) {
                                                if (!selectedDate || !selectMemberText || !selectTimeText || !selectSeatText) {
                                                    message.error('请选择预约日期、预约人数、预约时间、座位类型')
                                                    return
                                                }
                                            } else {
                                                if (!selectedDate || !selectMemberText || !selectTimeText) {
                                                    message.error('请选择预约日期、预约人数、预约时间')
                                                    return
                                                }
                                            }

                                            reservationFindMeal()
                                        }}
                                        style={{ width: '100%' }}
                                        placeholder="请选择套餐" options={[...meal]}
                                        value={selectMeal?.value}
                                        onChange={(value) => {
                                            const selectedOption = meal.find(option => option.value === value);
                                            if (selectedOption) {
                                                setSelectMeal(selectedOption);
                                            }
                                        }}
                                    />

                                </div>
                                {
                                    selectMeal?.value && <div className='form-item'>
                                        <div className='form-label'>金额明细</div>
                                        <div className='form-detail'>
                                            <div className='form-detail-title'>预约费用：</div>
                                            <div className='form-detail-price'>{detail.subscription_price}元/人</div>
                                        </div>
                                        <div className='form-detail'>
                                            <div className='form-detail-title'>套餐押金：</div>
                                            <div className='form-detail-price'>{detail.meal?.find(item => item.id === selectMeal?.value)?.deposit}元/人</div>
                                            <div style={{color:'#ea0025'}}>（押金不抵扣餐费，用餐后点击“就餐完成”，上传账单小票退款）</div>
                                        </div>
                                        <div className='form-detail'>
                                            <div className='form-detail-title'>总计：</div>
                                            <div className='form-detail-price'>{((detail.subscription_price * 1 + detail.meal?.find(item => item.id === selectMeal?.value)?.deposit * 1) * selectMemberText * 1).toFixed(2)}元</div>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className='form-bottom'>
                                <button className='form-submit' onClick={sureReservation}>提交预约申请</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>

    )
}

